import { Link } from '@tanstack/react-router';

import type { FooterColumn, FooterLink } from './useFooter';

interface FooterColumnLinksProps {
  column: FooterColumn;
  handleServiceClick: (
    e: React.MouseEvent,
    link: FooterLink,
    columnId: string
  ) => void;
}

const FooterColumnLinks = ({
  column,
  handleServiceClick,
}: FooterColumnLinksProps) => (
  <div className="flex flex-col gap-5">
    <h3 className="font-body text-sm font-semibold text-foreground-inverse">
      {column.title}
    </h3>
    <div className="flex flex-col gap-3">
      {column.links.map((link) => {
        if (link.disabled || column.id === 'services') {
          return (
            <button
              key={link.id}
              type="button"
              onClick={(e) => handleServiceClick(e, link, column.id)}
              className="cursor-pointer text-left font-body text-sm transition-colors hover:text-white/90"
              style={{ color: 'rgba(255, 255, 255, 0.7)' }}
            >
              {link.label}
            </button>
          );
        }

        return (
          <Link
            key={link.id}
            to={link.href}
            className="font-body text-sm transition-colors hover:text-white/90"
            style={{ color: 'rgba(255, 255, 255, 0.7)' }}
          >
            {link.label}
          </Link>
        );
      })}
    </div>
  </div>
);

export default FooterColumnLinks;
